import { RadioGroup } from "@design";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import type { PageVisibility } from "./frontmatter";

/**
 * Who can read a page: this space's editors, its members, or everyone in the organization.
 * Choosing "everyone" (publishing) is for the space's admins; editors can still lower it.
 */
export function VisibilityPicker({
  value,
  canPublish,
  onChange,
}: Readonly<{ value: PageVisibility; canPublish: boolean; onChange: (next: PageVisibility) => void }>) {
  const { t } = useTranslation("knowledge", { keyPrefix: "visibilityPicker" });
  const publishLocked = !canPublish && value !== "org";
  return (
    <fieldset className="flex flex-col gap-2">
      <legend>
        <Text variant="body-sm" weight="semibold">
          {t("label")}
        </Text>
      </legend>
      <RadioGroup
        aria-label={t("label")}
        value={value}
        onChange={(next) => onChange(next as PageVisibility)}
        options={[
          { value: "private", label: t("private"), description: t("privateHint") },
          { value: "members", label: t("members"), description: t("membersHint") },
          {
            value: "org",
            label: t("org"),
            description: publishLocked ? t("orgLocked") : t("orgHint"),
            disabled: publishLocked,
          },
        ]}
      />
    </fieldset>
  );
}
